import { render, staticRenderFns } from "./FontLoader.vue?vue&type=template&id=6da6eceb&"
import script from "./FontLoader.vue?vue&type=script&lang=js&"
export * from "./FontLoader.vue?vue&type=script&lang=js&"
import style0 from "./FontLoader.vue?vue&type=style&index=0&id=6da6eceb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports